import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

import { NotificationBannerProps } from './types'

const NotificationBanner = ({
  title,
  description,
  buttonText,
  icon,
  showAction = false,
  actionDisclaimer,
  onButtonClick
}: NotificationBannerProps): JSX.Element => {

  return (
    <S.Container>
      <S.ContentWrapper>
        {icon ? icon : null}
        <S.Content>
          <Typography variant='content1' weight='bolder'>
            {title}
          </Typography>
          <Typography variant='content2'>
            {description}
          </Typography>
        </S.Content>
      </S.ContentWrapper>
      {showAction && (
        <S.ActionWrapper>
          {actionDisclaimer && actionDisclaimer}
          <Button 
            onClick={onButtonClick}
            variant='contained'
            uppercase={false}
          >
            {buttonText}
          </Button>
        </S.ActionWrapper>
      )}
    </S.Container>
  )
}

export default NotificationBanner